import { Cylinder } from "lucide-react";
import { useSelector } from "react-redux";
import { CHECKPOINT_REPORT_FILTERS } from "../../config/table.config";
import FilterSearch from "../../../../components/common/FilterSearch";
import { formatJobcardReportData } from "../../utils/excelFormatters";

export const TABLE_SEARCH = {
  cylinder: ["cylinderNo"],
};

export const ReportSummaryCards = () => {
  const originalData = useSelector((state) => state.data.copyData);
  const TotalSites = originalData.length;
  // ...............get  excel data............
  const excelData = formatJobcardReportData(originalData);
  const excelConfig = {
    data: excelData,
    fileName: "Jobcard_checkpoint_Report",
    sheetName: "Checkpoint Report",
  };

  return (
    <div className="flex gap-2 mt-2">
      <div className="white-card w-[30%]">
        {/* Icon */}
        <div className={`p-2 rounded-md bg-blue-2`}>
          <Cylinder className="text-[#2e45a8]" />
        </div>

        {/* Content */}
        <div>
          <h3 className={`text-[#2e45a8] text-xl font-bold`}>{TotalSites}</h3>
          <p className="text-xs lg:text-[14px] font-figtreeMedium text-[#6b7aab]">
            Total Cylinders
          </p>
        </div>
      </div>
      <div className="white-card w-full">
        <FilterSearch
          categories={CHECKPOINT_REPORT_FILTERS}
          searchCategories={TABLE_SEARCH}
          excelConfig={excelConfig}
        />
      </div>
    </div>
  );
};
